export default __webpack_public_path__ + "static/media/241104_Shop_Bilder_7.8fc40839.png";